import { PlanungsFormat, planungsformate } from '../dtos';

export const isTermingruppe = (planungsformat: PlanungsFormat): boolean =>
  planungsformat === planungsformate.TERMINGRUPPE;
